/* External dependencies */
import React from 'react';
import { Button, Div, Text } from 'atomize';

/* Local dependencies */
import { CustomButton } from '../custom-button/custom-button';
import { MenuItem } from './menu-item';
import formatMessage from '../../../intl/formatMessage';

interface Section {
  name: string;
  values: string[];
}

export interface SidebarProps {
  title: string;
  sections: Section[];
  menuItemButtonStyle: Button;
  onAdd: (item: any) => void;
}

export function Sidebar(props: SidebarProps) {
  const { title, sections, menuItemButtonStyle, onAdd } = props;

  function getSectionValueSuffix(value: object) {
    return (
      <CustomButton
        {...menuItemButtonStyle}
        dataTestId={`custom-button-${value.name}`}
        onClick={() => onAdd(value)}
      />
    );
  }

  function renderSectionValues(values: string[], parentName: string) {
    const valuesContent = values.map((value, index) => (
      <MenuItem
        name={value}
        parentName={parentName}
        index={index}
        suffix={getSectionValueSuffix}
      />
    ));

    const emptyContent = <Text>{formatMessage('Empty')}</Text>;

    return values.length ? valuesContent : emptyContent;
  }

  function renderSections(sections: Section[]) {
    return sections.map((section) => {
      const { name, values } = section;

      return (
        <Div
          tag="section"
          d="flex"
          flexDir="column"
          w="100%"
          key={name}
          style={{ gap: '10px' }}
        >
          <Text
            tag="h4"
            textSize="16px"
            textWeight="600"
            style={{ wordBreak: 'break-all' }}
          >
            {name}
          </Text>

          {renderSectionValues(values, name)}
        </Div>
      );
    });
  }

  return (
    <Div
      d="flex"
      flexDir="column"
      align="center"
      w="250px"
      bg="table_cell_background"
      p="15px"
    >
      <Div
        d="flex"
        flexDir="column"
        align="center"
        bg="input_filled_bg"
        w="100%"
        h="100%"
        p={{ b: '15px', x: '15px' }}
        overflow="auto"
        style={{
          gap: '20px',
          scrollbarGutter: 'stable',
        }}
      >
        <Div
          pos="sticky"
          bg="input_filled_bg"
          w="100%"
          zIndex="10"
          p={{ t: '15px' }}
          style={{ top: 0 }}
        >
          <Text
            tag="h1"
            textSize="subheader"
            textAlign="center"
            textColor="table_cell_text_color"
          >
            {title}
          </Text>
        </Div>

        {renderSections(sections)}
      </Div>
    </Div>
  );
}
